import { render, staticRenderFns } from "./transfer.dialog.vue?vue&type=template&id=4dd2d60e&scoped=true"
import script from "./transfer.dialog.vue?vue&type=script&lang=js"
export * from "./transfer.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2d60e",
  null
  
)

export default component.exports